export default {
  en: {
    attributes: {
      firstName: 'first name',
      lastName: 'last name',
      secondLastName: 'second last name',
      email: 'email',
      phone: 'phone',
      gender: 'gender',
      birthYear: 'birth year',
      birthDate: 'birth date',
      postalCode: 'postal code',
      name: 'name',
      description: 'description',
      startsAt: 'starts at',
      endsAt: 'ends at',
      timezone: 'timezone',
      placeName: 'place name',
      address: 'address',
      locality: 'locality',
      country: 'country',
      latitude: 'latitude',
      longitude: 'longitude',
      ticketType: 'ticket type',
      company: 'company name',
      password: 'password',
      passwordConfirmation: 'password confirmation',
      terms: 'platform terms',
      privacy: 'privacy policy',
      processorAgreement: 'contrato de encargado de tratamiento',
      quantity: 'quantity',
      limit: 'limit',
      areaName: 'access name',
      activityName: 'activity name',
      giftName: 'gift name',
      fieldsToShare: 'fields to share',
      expiresAt: 'expiration date',
      alias: 'alias',
      user: 'user',
      message: 'message',
      rateTitle: 'Rate title',
      commentTitle: 'Comment title',
      from: 'From the date of',
      to: 'Until the date of',
      sendAt: 'Day and hour'
    },
    messages: {
      password: (field, min) => `Password must be a minimum of ${min} characters long, including at least one letter and one number`,
      checked: (field, params) => params.hasOwnProperty('companion')
        ? `At least one ${field} must be checked.`
        : `Field ${field} is required.`,
      birthdate: (field, params) => `You have to be over ${params.minAge}.`,
      date_iso: (field, params) => `Fiend ${field} must have a date between ${params.min} and ${params.max}.`
    }
  },
  es: {
    attributes: {
      firstName: 'nombre',
      lastName: 'apellido',
      secondLastName: 'segundo apellido',
      email: 'email',
      phone: 'teléfono',
      gender: 'género',
      birthYear: 'año de nacimiento',
      birthDate: 'fecha de nacimiento',
      postalCode: 'código postal',
      name: 'nombre',
      description: 'descripción',
      startsAt: 'empieza el',
      endsAt: 'finaliza el',
      timezone: 'zona horaria',
      placeName: 'nombre del lugar',
      address: 'dirección',
      locality: 'localidad',
      country: 'pais',
      latitude: 'latitud',
      longitude: 'longitud',
      ticketType: 'tipo de entrada',
      company: 'nombre de empresa',
      password: 'contraseña',
      passwordConfirmation: 'confirmación de contraseña',
      terms: 'terminos de la plataforma',
      privacy: 'política de privacidad',
      processorAgreement: 'contrato de encargado de tratamiento',
      quantity: 'cantidad',
      limit: 'limitado',
      areaName: 'nombre del acceso',
      activityName: 'nombre de la actividad',
      giftName: 'nombre del regalo',
      fieldsToShare: 'campos a compartir',
      expiresAt: 'fecha de expiración',
      alias: 'alias',
      user: 'usuario',
      message: 'mensaje',
      rateTitle: 'Título de la valoración',
      commentTitle: 'Título del comentario',
      from: 'Desde la fecha de',
      to: 'Hasta la fecha de',
      sendAt: 'Día y hora'
    },
    messages: {
      password: (field, min) => `La contraseña debe tener como mínimo ${min} caracteres y contener al menos un número y una letra`,
      checked: (field, data) => data.hasOwnProperty('companion')
        ? `Al menos un ${field} debe ser seleccionado.`
        : `El campo ${field} es obligatorio.`,
      birthdate: (field, params) => `Tienes que ser mayor de ${params.minAge} años.`,
      date_iso: (field, params) => `El campo ${field} tiene que tener una fecha comprendida entre ${params.min} y ${params.max}.`
    }
  }
}
